import { Point, Scale, TranslatePointScreen2To1 } from "../../../MyHelpers";
import { ImageResource } from "../../../ResourceManager/ImageResource";
import { IWriteOnlyResourceManager } from "../../../ResourceManager/ResourceManager";
import { Settings } from "../../../Settings";
import { BigSymbolFreegamesBonus } from "./BigSymbolFreegames";
//import { BigSymbolFreegamesConfig } from "./BigSymbolFreegamesConfig";
import * as PIXI from 'pixi.js';
import { BigSymbolFreegamesBonusParams } from "./BigSymbolFreegamesParams";
import { BigSymbolFreegamesCommonConfiguration } from "../../../api";

export class BigSymbolFreeGameBonus_2Screen extends BigSymbolFreegamesBonus {
    public override CreateTransitionPixi(app? : PIXI.Application<HTMLCanvasElement>): void {
		//throw new Error("Method not implemented.");
		this.transitionView.CreateTransitionPixi(app);
	}
	public override DestroyTransition(): void {
		//throw new Error("Method not implemented.");
		this.transitionView.DestroyTransitionPixi();
	}

    //CHANGE POSITION PLUS ONE TARGET
    protected override plusOneTarget: Point = TranslatePointScreen2To1(new Point(Scale.X(228), Scale.Y(750)));

    //CREATE DIV TRASITION ONLY IMG
    //protected transitionView: HTMLElement = null;


    protected PathGame: string = null;

    public constructor(gameName: string, params: BigSymbolFreegamesBonusParams, config: BigSymbolFreegamesCommonConfiguration) {
        super(gameName, params, config);
        this.PathGame = Settings.ResourcesFolder + "multigame/slot/" + gameName + "/resources/"

    }

    protected override async BasePrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        await super.BasePrepare(resourceManager);
        resourceManager.Add(new ImageResource(this.PathGame + "BackgroundTransition.png", this.resid.ScopedResourceName(["BackgroundTransition", "image"])));
    }

    protected override ExtraSymbolsAbove(): number {
        //Quit Exta Symbol
        let reel: number = 0;
        return reel
    }
}
